import { render } from "./DadataSuggestions.vue?vue&type=template&id=aaf7684a"
import script from "./DadataSuggestions.vue?vue&type=script&lang=js"
export * from "./DadataSuggestions.vue?vue&type=script&lang=js"

import "./DadataSuggestions.vue?vue&type=style&index=0&id=aaf7684a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__